import { DataStorage } from '@studyportals/data-storage';
import {
	ListName,
	ListPageType,
	Product,
	Tracker,
	StudyCardImpressionData,
	ClickEcommerceTrackingData,
	ProductType,
	Action,
} from '@studyportals/datalake-event-tracker';
import { IItemContext } from '@studyportals/datalayer';
import { ITrackingData } from '@studyportals/datalake-event-tracker';
import { getPageTypeOrUrl } from './PageTypeMapping';
import global from '@/utils/global';

class Tracking {
	private tracker = new Tracker(Product.INLINE_SEARCH, true, true);
	private trackerWithoutGA = new Tracker(Product.INLINE_SEARCH, false, true);

	public snowPlowSiteSearch(searchTerms: string[], filters: object, resultsFound: number): void {
		if (searchTerms.length === 0) {
			throw new Error('Snowplow enrich rejects empty searchTerms.');
		}

		this.tracker.trackSiteSearch({
			terms: searchTerms,
			filters,
			totalResults: resultsFound,
		});
	}

	public searchCardImpression(programmeId: number, universityId: number, order: number): void {
		const data = new StudyCardImpressionData(
			programmeId,
			this.getListPageType(),
			ListName.INLINE_SEARCH,
			universityId,
			undefined,
			undefined,
			order,
			undefined,
			undefined,
		);

		try {
			this.tracker.trackStudyCardImpression(data);
		} catch (error) {
			throw new Error(JSON.stringify(error));
		}
	}

	public suggestionClick(
		suggestionIndex: number,
		suggestionText: string,
		userInput: string,
	): void {
		const cleanedUserInput = global.replaceDashWithSpace(global.escapeRegexSpecialChars(userInput)).toLowerCase();
		const data: ITrackingData = {
			category: Product.INLINE_SEARCH,
			action: Action.CLICK,
			label: `${suggestionText.toLowerCase()} #${(suggestionIndex + 1).toString()}`,
			property: `${cleanedUserInput}`
		};

		this.trackerWithoutGA.trackStructuredEvent(data);
	}

	public searchExecuted(
		userInput: string,
	): void {
		const cleanedUserInput = global.replaceDashWithSpace(global.escapeRegexSpecialChars(userInput)).toLowerCase();

		const data: ITrackingData = {
			category: Product.INLINE_SEARCH,
			action: Action.SEND,
			label: `${cleanedUserInput}`,
		};

		this.trackerWithoutGA.trackStructuredEvent(data);
	}

	public searchProgrammeClick(programmeId: number, universityId: number, order: number): void {
		const data = new ClickEcommerceTrackingData(
			programmeId,
			ListPageType.SEARCH,
			ListName.INLINE_SEARCH,
			universityId,
			undefined,
			undefined,
			order,
			undefined,
			undefined,
			ProductType.STUDY,
		);

		try {
			this.storeTrackingData(data.getTrackingContext());

			this.tracker.trackStudyCardClick(data);
		} catch (error) {
			throw new Error(JSON.stringify(error));
		}
	}

	private storeTrackingData(context: IItemContext): void {
		const key = 'InlineStudyCardClick';
		const value = DataStorage.retrieve(key) as string;
		let data: IItemContext[] = [];

		if (value !== '') {
			data = data.concat(JSON.parse(value) as []);
		}

		data.push(context);
		DataStorage.store(key, JSON.stringify(data), 30);
	}

	private getListPageType(): ListPageType | string {
		const pathname = window.location.pathname;

		return getPageTypeOrUrl(pathname);
	}
}

export default new Tracking();